import BaseValidator from 'services/validations/base-validator';
import {getUnique, getPropValues} from 'helpers/array-helper';

class MinGamesValidator extends BaseValidator {
    private minGames: number = 0;

    protected runValidation(): void {
        // @ts-ignore
        const {sportConfig} = this.dependencies;

        this.minGames = sportConfig.getConfigProp('minGames', 0);

        if (this.isGamesQuantityEnough()) {
            return;
        }

        this.addError(`A minimum of ${this.minGames} games needed.`);
    }

    private isGamesQuantityEnough(): boolean {
        // @ts-ignore
        const {sportConfig} = this.dependencies;

        const uniqueGamesQuantity = this.calcUniqueGamesQuantity();

        return this.minGames <= uniqueGamesQuantity;
    }

    private calcUniqueGamesQuantity(): number {
        // @ts-ignore
        const {playersDividedByPosition} = this.dependencies;

        const games = getPropValues(playersDividedByPosition, 'gameInfo');

        return getUnique(games).length;
    }
}

export {MinGamesValidator};
